import {gql} from '@apollo/client';
import {css, StyleSheet} from 'aphrodite';
import {DocumentNode} from 'graphql';
import React from 'react';
import _ from 'underscore';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';
import EditableTextField, {TextFieldType} from 'ui-library/inputs/EditableTextField';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';

import {WebhookConfigurationSectionWebhookConfiguration as WebhookConfigurationSectionWebhookConfigurationGQL} from './__generated/WebhookConfigurationSectionWebhookConfiguration';

type WebhookConfigurationSectionWebhookConfiguration = ExtractByTypename<
  WebhookConfigurationSectionWebhookConfigurationGQL['webhookConfigurations'][number],
  'WebhookConfigurationNode'
>;

export const WEBHOOK_CONFIGURATION_SECTION_WEBHOOK_CONFIGURATION: DocumentNode = gql`
  fragment WebhookConfigurationSectionWebhookConfiguration on BenchlingAppNode {
    id
    webhookConfigurations {
      ... on InaccessibleInfoNode {
        invalidId
      }
      ... on WebhookConfigurationNode {
        id
        endpointPublicKeySet
        webhookUrl
      }
    }
  }
`;

export {WebhookConfigurationSectionWebhookConfiguration};

export interface WebhookURLSectionProps {
  onUpdateWebhookUrl: (newWebhookURL: string) => void;
  webhookUrl: string | null;
}

export default function WebhookURLSection({
  onUpdateWebhookUrl,
  webhookUrl,
}: WebhookURLSectionProps): JSX.Element {
  const webhookDocLink = (
    <a target="_blank" rel="noopener noreferrer" href="https://docs.benchling.com/docs/webhook-verification">
      webhook verification documentation
    </a>
  );
  const tooltip = <span>To learn more about verifying webhooks, visit our {webhookDocLink}.</span>;

  return (
    <InputWrapper
      id={_.uniqueId('benchlingAppDetail')}
      label="Webhook URL"
      labelStyle={FieldLabel.STYLES.LABEL}
      help={tooltip}
      helpInteraction={FloatingInteraction.HOVER}
    >
      <div className={css(styles.webhookInput)}>
        <EditableTextField
          emptyValueAllowed={true}
          requestChange={onUpdateWebhookUrl}
          type={TextFieldType.TEXT}
          value={webhookUrl || ''}
          isFullWidth={true}
          dataTestAttrs={{component: 'WebhookURLSection', element: 'editableTextField'}}
        />
      </div>
    </InputWrapper>
  );
}

const styles = StyleSheet.create({
  webhookInput: {
    minWidth: '270px',
  },
});
